@switch(icon()){ @case('book-open'){

<app-book-open [size]="size()"></app-book-open>
} @case('calendar-days'){

<app-calendar-days [size]="size()"></app-calendar-days>
} @case('chevron-down'){

<app-chevron-down [size]="size()"></app-chevron-down>
} @case('close'){

<app-close [size]="size()"></app-close>
} @case('edit'){

<app-edit [size]="size()"></app-edit>
} @case('play'){

<app-play [size]="size()"></app-play>
} @case('search'){

<app-search [size]="size()"></app-search>
} @case('sparkles'){

<app-sparkles [size]="size()"></app-sparkles>
} @case('trash'){

<app-trash [size]="size()"></app-trash>
} @case('arrow-left'){

<app-arrow-left [size]="size()"></app-arrow-left>
} @case('info'){

<app-info [size]="size()"></app-info>
} @case('alert-triangle'){

<app-alert-triangle [size]="size()"></app-alert-triangle>
} @case('check'){

<app-check [size]="size()"></app-check>
} @case('spinner'){

<app-spinner [size]="size()"></app-spinner>
} @case('whatsapp'){

<app-whatsapp [size]="size()"></app-whatsapp>
} @case('menu'){

<app-menu [size]="size()"></app-menu>
} @case('home'){

<app-home [size]="size()"></app-home>
} @case('plus'){

<app-plus [size]="size()"></app-plus>
} @case('clock'){

<app-clock [size]="size()"></app-clock>
} @case('user'){

<app-user [size]="size()"></app-user>
} }
